import { makeStyles } from '@material-ui/core';

import { red } from 'shared/styles/colors';

export default makeStyles({
  root: {
    padding: '0.25rem 0.75rem',
    fontSize: '0.75rem',
    borderRadius: '0.5rem',
    borderColor: red[60],
    color: red[60],
    '&:hover': {
      borderColor: red[60],
      backgroundColor: 'transparent',
      color: red[60],
    },
  },
});
